import { useGetLocale } from '@legacy/components/global/LocaleProvider';
import { getDateStringFromSiteLocale } from '@legacy/utils/date';
import { formatTime } from '@legacy/utils/time';

export const useExcelConfig = () => {
  const siteLocale = useGetLocale();

  return {
    ignoreColumns: ['billableStatus', 'bookingStatus'],
    fileName: 'Time_registrations.xlsx',
    sheetName: 'Time_registrations',
    titleName: 'TimeLog - Time_registrations',
    valueParser: {
      date: (value: number | string) =>
        getDateStringFromSiteLocale(new Date(value), siteLocale),
      actualHours: (value: number | string) => formatTime(value, siteLocale),
      hourlyRate: (value: number | string) => formatTime(value, siteLocale),
      actualAmount: (value: number | string) => formatTime(value, siteLocale),
    },
  };
};
